import { createSlice } from "@reduxjs/toolkit";
import { welcomeEmailTemplateListAPI } from "../../services/welcomeEmailTemplateList";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const welcomeEmailTemplateListSlice = createSlice({
  name: "welcomeEmailTemplateList",
  initialState: data,
  reducers: {
    welcomeEmailTemplateInfo(state) {
      state.isLoading = true;
    },
    welcomeEmailTemplateSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    welcomeEmailTemplateFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    welcomeEmailTemplateReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const welcomeEmailTemplateListHandler = (data) => async (dispatch) => {
  try {
    dispatch(welcomeEmailTemplateAction.welcomeEmailTemplateInfo());
    const response = await welcomeEmailTemplateListAPI(data);
    dispatch(welcomeEmailTemplateAction.welcomeEmailTemplateSuccess(response));
  } catch (e) {
    dispatch(welcomeEmailTemplateAction.welcomeEmailTemplateFailure(e));
  }
};
export default welcomeEmailTemplateListSlice.reducer;
export const welcomeEmailTemplateAction = welcomeEmailTemplateListSlice.actions;
